export enum AudiencePropertiesUnderValidation {
	AudienceName = 'AudienceName',
	OpenOn = 'OpenOn',
	CloseOn = 'CloseOn',
	OpenCloseDates = 'OpenCloseDates',
	DistributionType = 'DistributionType',
	Distribution = 'Distribution',
}
